<template>

    <el-select
            v-model="userFilter"
            filterable
            :placeholder="placeholder"
            @change="onChange"
            :class="hasError ? 'has-error user-selector' : 'user-selector'"
    >
        <el-option :label="nullLabel" :value="null"/>
        <el-option v-if="includeMe" label="Me" :value="loggedInUser.id"/>
        <el-option-group label="Reps" v-if="includeReps">
            <el-option
                    v-for="user in reps"
                    :key="user.id"
                    :label="userLabel(user)"
                    :value="user.id">
            </el-option>
        </el-option-group>
        <el-option-group label="Admin" v-if="includeAdmins">
            <el-option
                    v-for="user in admins"
                    :key="user.id"
                    :label="userLabel(user)"
                    :value="user.id">
            </el-option>
        </el-option-group>
        <el-option-group label="Customers" v-if="includeDealers">
            <el-option
                    v-for="user in dealers"
                    :key="user.id"
                    :label="userLabel(user)"
                    :value="user.id">
            </el-option>
        </el-option-group>
    </el-select>
</template>
<script>

    export default {
        props: {
            value: Number,
            state: Boolean,
            placeholder: {
                type: String,
                default: 'Filter by user'
            },
            nullLabel: {
                type: String,
                default: '-'
            },
            filterUsersFunction: {
                type: Function,
                default: null,
            },
            allowEmpty: {
                type: Boolean,
                default: false,
            },
            includeMe: {
                type: Boolean,
                default: true,
            },
            namesFirst: {
                type: Boolean,
                default: false,
            },
            filterStatus: {
                type: Number,
                default: 1,
            },
            filterGlobal: {
                type: Boolean,
                default: false,
            },
            includeAdmins: {
                type: Boolean,
                default: true,
            },
            includeReps: {
                type: Boolean,
                default: true,
            },
            includeDealers: {
                type: Boolean,
                default: true,
            },
            adminsIncludeSuperAdmin: {
                type: Boolean,
                default: false,
            },
            filterBySharedSalesReps: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                userFilter : null,
                users : [],
            }
        },
        created(){
            if (this.value) {
                this.userFilter = parseInt(this.value)
            }
            this.getusers()
        },
        computed: {
            reps(){
                if (this.users && this.users.length) {
                    return this.users.filter(u => u.role_id === 3)
                }
                return []
            },
            admins(){
                if (this.users && this.users.length) {
                    return this.users.filter(u => u.role_id === 1 || (this.adminsIncludeSuperAdmin && u.role_id === 4))
                }
                return []
            },
            dealers(){
                if (this.users && this.users.length) {
                    return this.users.filter(u => u.role_id === 2)
                }
                return []
            },
            hasError(){
                if (this.state) {
                    return true
                }
                return false
            }
        },
        methods: {
            onChange(){
                this.$emit('input', this.userFilter)
                this.$emit('change', this.userFilter)
            },
            async getusers(){
                let res = await this.$store.dispatch('users/getUsers', {args: {
                    sort_by: 'company_id',
                    sort_asc: true,
                    per_page: 1000,
                    filter_by_status: this.filterStatus,
                    filter_by_shared_sales_reps: this.filterBySharedSalesReps,
                }});
                if (res && res.data) {
                    let reps = [];
                    res.data.forEach(u => {
                        if (this.filterUsersFunction && !this.filterUsersFunction(u)) {
                            return;
                        }
                        if (this.includeMe && u.id !== this.loggedInUser.id) {
                            reps.push(u)
                        } else {
                            reps.push(u)
                        }
                    })
                    this.users = reps
                }
            },
            userLabel(user) {
                let label = ''
                if (user.company && user.company.name) {
                    if (this.namesFirst) {
                        label = `${user.name} (${user.company.name})`
                    } else {
                        label = `${user.company.name} (${user.name})`
                    }
                } else {
                    label = user.name
                }
                return label
            }
        }


    }
</script>





// WEBPACK FOOTER //
// resources/js/components/Common/UserSelector.vue